export default __webpack_public_path__ + "static/media/location.d797c180.svg";